<template>
  <div
    :class="`tabs__content ${!isActive ? 'tabs__content--hidden' : ''}`"
    :data-content="id"
    v-if="isActive">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'tab',
  props: ['name', 'id', 'iconName', 'property', 'hasInput'],
  data () {
    return {
      isActive: true
    }
  }
}
</script>

<style lang="sass" scoped>
  @import '@/styles/component-utils.sass'
  .tabs
    &__content
      border: 1px solid $color-border-dark
      padding: $spacing-base
      @include clearfix
      &--hidden
        display: none
</style>
